export default "__VITE_ASSET__bIkG6EnW__"